import { AddressService } from 'shared/services';

//  Actions
const GET_ADDRESS = 'address/GET_ADDRESS';
const GET_ADDRESS_SUCCESS = 'address/GET_ADDRESS_SUCCESS';
const GET_ADDRESS_ERROR = 'address/GET_ADDRESS_ERROR';
const GET_INSTITUTION_ADDRESS_SUCCESS = 'address/GET_INSTITUTION_ADDRESS_SUCCESS ';
const GET_INSTITUTION_ADDRESS_ERROR = 'address/GET_INSTITUTION_ADDRESS_ERROR';
const UPDATE_ADDRESS_SUCCESS = 'address/UPDATE_ADDRESS_SUCCESS';
const UPDATE_ADDRESS_ERROR = 'address/UPDATE_ADDRESS_ERROR';

const initialState = {
  addressLoaded: false,
  address: {},
  error: {},
}

export default function addressReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ADDRESS:
      return Object.assign({}, state, { addressLoaded: false });
    case GET_ADDRESS_SUCCESS:
      return Object.assign({}, state, { address: action.data, addressLoaded: true });
    case GET_ADDRESS_ERROR:
      return Object.assign({}, state, { error: action.error, addressLoaded: false });
    case GET_INSTITUTION_ADDRESS_SUCCESS: {
      const address = action.data.find(element => element.status === 1);
      return Object.assign({}, state, { address, addressLoaded: true });
    }
    case GET_INSTITUTION_ADDRESS_ERROR:
      return Object.assign({}, state, { error: action.error, addressLoaded: false });
    case UPDATE_ADDRESS_SUCCESS:
      return Object.assign({}, state, { address: action.data, addressLoaded: true });
    case UPDATE_ADDRESS_ERROR:
      return Object.assign({}, state, { error: action.error });
    default:
      return state;
  }
}

export function getAddressLoading() {
  return { type: GET_ADDRESS };
}

export function getAddressSuccess(data) {
  return { type: GET_ADDRESS_SUCCESS, data };
}

export function getAddressError(error) {
  return { type: GET_ADDRESS_ERROR, error };
}

export function getTestCenterAddressSuccess(data) {
  return { type: GET_INSTITUTION_ADDRESS_SUCCESS, data };
}

export function getTestCenterAddressError(error) {
  return { type: GET_INSTITUTION_ADDRESS_ERROR, error };
}


export function updateAddressSuccess(data) {
  return { type: UPDATE_ADDRESS_SUCCESS, data };
}

export function updateAddressError(error) {
  return { type: UPDATE_ADDRESS_ERROR, error };
}


export function getAddress(userId) {
  return function (dispatch) {
    dispatch(getAddressLoading());
    return AddressService.getAddress(userId)
      .then((response) => {
        dispatch(getAddressSuccess(response));
      })
      .catch((error) => {
        dispatch(getAddressError(error));
      });
  };
}

export function updateAddress(address) {
  return function (dispatch) {
    return AddressService.updateAddress(address)
      .then((response) => {
        dispatch(updateAddressSuccess(response));
      })
      .catch((error) => {
        dispatch(updateAddressError(error));
      });
  };
}


export function getTestCenterAddress(testCenterId) {
  return function (dispatch) {
    return AddressService.getAddressesByTestCenter(testCenterId)
      .then((response) => {
        dispatch(getTestCenterAddressSuccess(response));
      })
      .catch((error) => {
        dispatch(getTestCenterAddressError(error));
      });
  };
}